export default __webpack_public_path__ + "static/media/dispatch-work-order-white-icon.b5681fd0.svg";